import { Grid, Typography } from '@mui/material'
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector,
    GridToolbarExport,
    GridToolbarFilterButton,
    GridToolbarQuickFilter
} from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react'

const COLUMNS = [
    { field: 'exchange', headerName: 'Exchange' },
    { field: 'symbol', headerName: 'Symbol', width: 150 },
    { field: 'scripCode', headerName: 'Scrip code' },
    { field: 'companyName', headerName: 'Company Name', width: 250 },
    { field: 'isin', headerName: 'ISIN', width: 150 },
    { field: 'stage', headerName: 'Stage', width: 130 },
    { field: 'term', headerName: 'Term', width: 130 },
    { field: 'type', headerName: 'Type' },
    { field: 'entryDate', headerName: 'Entry date', width: 130 },
    { field: 'exitDate', headerName: 'Exit date', width: 130 },
]

const COLUMNS_DHAN = [
    { field: 'exchange', headerName: 'Exchange' },
    { field: 'symbol', headerName: 'Symbol', width: 150 },
    { field: 'companyName', headerName: 'Company Name', width: 250 },
    { field: 'securityId', headerName: 'Security Id', width: 130 },
    { field: 'series', headerName: 'Series', width: 130 },
    { field: 'type', headerName: 'Type' },
    { field: 'entryDate', headerName: 'Entry date', width: 130 },
    { field: 'exitDate', headerName: 'Exit date', width: 130 },
]

const SurveillanceHistory = ({ user }) => {
    const [surveillanceHistory, setSurveillanceHistory] = useState([])
    const [dhanSurveillanceHistory, setDhanSurveillanceHistory] = useState([])

    useEffect(() => {
        fetch('/algo-trading/api/admin/surveillance-history', {
            headers: { 'Authorization': user?.credential },
        }).then(r => r?.json())
            .then(setSurveillanceHistory)
    }, [user])

    useEffect(() => {
        fetch('/algo-trading/api/admin/surveillance-history-dhan', {
            headers: { 'Authorization': user?.credential },
        }).then(r => r?.json())
            .then(setDhanSurveillanceHistory)
    }, [user])
    return (
        <>
            <Grid container marginY={5}>
                <DataGrid
                    sx={{
                        bgcolor: 'white',
                    }}
                    columns={COLUMNS_DHAN}
                    rows={dhanSurveillanceHistory}
                    slots={{
                        toolbar: () => <GridToolbarContainer style={{ justifyContent: 'space-around' }}>
                            <Typography variant='h5' align='center'>Surveillance History Dhan</Typography>
                            <GridToolbarColumnsButton />
                            <GridToolbarFilterButton />
                            <GridToolbarDensitySelector />
                            <GridToolbarExport />
                            <GridToolbarQuickFilter />
                        </GridToolbarContainer>
                    }}
                />
            </Grid>
            <Grid container>
                <DataGrid
                    sx={{
                        bgcolor: 'white',
                    }}
                    columns={COLUMNS}
                    rows={surveillanceHistory}
                    slots={{
                        toolbar: () => <GridToolbarContainer style={{ justifyContent: 'space-around' }}>
                            <Typography variant='h5' align='center'>Surveillance History</Typography>
                            <GridToolbarColumnsButton />
                            <GridToolbarFilterButton />
                            <GridToolbarDensitySelector />
                            <GridToolbarExport />
                            <GridToolbarQuickFilter />
                        </GridToolbarContainer>
                    }}
                />
            </Grid>
        </>

    )
}

export default SurveillanceHistory